<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="Vector 4" d="M1 3.82609L3.42424 6L9 1" stroke="#FF4E02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
